import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-versions" }

import TabVersion from "@/components/tabs/common/version.vue";

import type { VersionOwnerType } from "@/common/types/common/version";


export default /*@__PURE__*/_defineComponent({
  __name: 'versions',
  props: {
    ownerType: {},
    ownerId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TabVersion, {
      "owner-type": __props.ownerType,
      "owner-id": __props.ownerId,
      "relation-type": "this_console"
    }, null, 8, ["owner-type", "owner-id"]),
    _createVNode(TabVersion, {
      "owner-type": __props.ownerType,
      "owner-id": __props.ownerId,
      "relation-type": "other_systems"
    }, null, 8, ["owner-type", "owner-id"]),
    _createVNode(TabVersion, {
      "owner-type": __props.ownerType,
      "owner-id": __props.ownerId,
      "relation-type": "compilation"
    }, null, 8, ["owner-type", "owner-id"]),
    _createVNode(TabVersion, {
      "owner-type": __props.ownerType,
      "owner-id": __props.ownerId,
      "relation-type": "console_memory"
    }, null, 8, ["owner-type", "owner-id"]),
    _createVNode(TabVersion, {
      "owner-type": __props.ownerType,
      "owner-id": __props.ownerId,
      "relation-type": "unofficial_other_systems"
    }, null, 8, ["owner-type", "owner-id"])
  ]))
}
}

})